<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Invite Participants to Another Event</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="eventTypeSelect">Event Type</label>
      <select id="eventTypeSelect" class="custom-select" name="eventType"
              [(ngModel)]="selectedEventType" (ngModelChange)="handleSelectedEventType()"
              [disabled]="loadingSave"
              [class.disabled]="loadingSave"
              *ngIf="!loadingEventTypes" required>
        <option [ngValue]="null" disabled>-- Select an Event Type --</option>
        <option *ngFor="let eventType of eventTypeList"
                [ngValue]="eventType">
          {{ eventType.name }}
        </option>
      </select>
      <select id="eventTypeSelectLoading" class="custom-select" name="eventType"
              *ngIf="loadingEventTypes" disabled>
        <option selected>Loading...</option>
      </select>
    </div>

    <ng-container *ngIf="selectedEventType && !loadingSelectedEvent">

      <ng-container *ngIf="selectedEventType.schedule_type !== ScheduleType.rolling">

        <ng-container *ngIf="!selectedEvent">

          <p>Select a Time Slot</p>

          <div class="mb-2">
            <app-date-picker [id]="'selectedDate'"
                             [(content)]="selectedDate"
                             (contentChange)="loadEventsForDate()"
                             [small]="true"></app-date-picker>
          </div>

          <div class="rounded-table-wrapper rounded-table-tight">
            <table class="table table-sm">
              <thead>
              <tr>
                <th scope="col">Time</th>
                <th scope="col">R/C</th>
                <th scope="col">Location</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngIf="!loadingEventsForDate">
                <tr *ngFor="let scheduledEvent of scheduledEventsForDate">
                  <td>
                    {{ timeStringFromISO8601(scheduledEvent.start_datetime, scheduledEvent.time_zone) }} -
                    {{ timeStringFromISO8601(scheduledEvent.end_datetime, scheduledEvent.time_zone) }}
                    <span *ngIf="scheduledEvent.is_cancelled">&ndash; <b>Cancelled</b></span>
                    <ng-container *ngIf="scheduledEvent.event_part_count > 1">
                      (Part {{ scheduledEvent.event_part_number }} of {{ scheduledEvent.event_part_count }})
                    </ng-container>
                    <ng-container *ngIf="scheduledEvent.schedule_name">
                      <br>
                      <i>{{ scheduledEvent.schedule_name }}</i>
                    </ng-container>
                    <ng-container *ngIf="scheduledEvent.customer_facing_name && (scheduledEvent.customer_facing_name !== scheduledEvent.schedule_name)">
                      <br>
                      <i>{{ scheduledEvent.customer_facing_name }}</i>
                    </ng-container>
                  </td>
                  <td>
                    <span placement="bottom" style="white-space: nowrap"
                          [ngbTooltip]="eventFullDueToSecondaryCapacity(scheduledEvent) ? 'Facility capacity or booking limit reached for this time slot.' : ''">
                      {{ scheduledEvent.reservation_count }} / {{ scheduledEvent.capacity }}
                      <span *ngIf="eventFullDueToSecondaryCapacity(scheduledEvent)">*</span>
                    </span>
                  </td>
                  <td>
                    {{ scheduledEvent.location_name }}
                  </td>
                  <td class="table-sm-button-cell">
                    <button class="btn btn-sm btn-outline-primary table-sm-button float-right"
                            type="button"
                            (click)="loadSelectedEvent(scheduledEvent.event_id)">
                      Select
                    </button>
                  </td>
                </tr>
                <tr *ngIf="scheduledEventsForDate.length === 0">
                  <td colspan="99">No time slots for the selected date</td>
                </tr>
              </ng-container>
              <tr *ngIf="loadingEventsForDate">
                <td colspan="99">Loading...</td>
              </tr>
              </tbody>
            </table>
          </div>

        </ng-container>

        <ng-container *ngIf="loadingSelectedEvent">
          <p class="text-muted">
            Loading event...
          </p>
        </ng-container>

        <ng-container *ngIf="selectedEventType && !loadingSelectedEvent && selectedEvent">
          <button class="btn btn-sm btn-link float-right" style="margin-top: -6px"
                  [disabled]="loadingSave"
                  [class.disabled]="loadingSave"
                  type="button"
                  (click)="selectedEvent = null">
            Clear Selection
          </button>

          <ng-container *ngIf="selectedEvent.event_parts.length === 1">
            <p>
              Selected event at {{ selectedEvent.location_name }}:
              <b>
                {{ selectedEvent.event_parts[0].start_local_date }},
                {{ selectedEvent.event_parts[0].start_local_time }} -
                {{ selectedEvent.event_parts[0].end_local_time }}
              </b>
            </p>
          </ng-container>
          <ng-container *ngIf="selectedEvent.event_parts.length > 1">
            <p class="mb-1">Selected multi-part event at {{ selectedEvent.location_name }}:</p>
            <ul>
              <li *ngFor="let eventPart of selectedEvent.event_parts">
                <b>
                  {{ eventPart.start_local_date }},
                  {{ eventPart.start_local_time }} -
                  {{ eventPart.end_local_time }}
                </b>
              </li>
            </ul>
          </ng-container>
        </ng-container>

      </ng-container>

      <ng-container *ngIf="selectedEventType.schedule_type === ScheduleType.rolling">

        <div class="form-group">
          <label for="selectedRoster">Roster</label>
          <select class="custom-select"
                  id="selectedRoster"
                  name="selectedRoster"
                  *ngIf="!loadingRosters"
                  [disabled]="loadingSave"
                  [class.disabled]="loadingSave"
                  [(ngModel)]="selectedRoster">
            <option [ngValue]="null" disabled>
              - Select a Roster -
            </option>
            <option *ngFor="let roster of rosters"
                    [ngValue]="roster">
              {{ roster.name }}
            </option>
          </select>
          <select class="custom-select disabled" disabled
                  *ngIf="loadingRosters">
            <option>
              Loading...
            </option>
          </select>
        </div>

        <div class="mb-3">
          <label for="startDate">Start Date (optional)</label>
          <app-date-picker [id]="'startDate'"
                           [(content)]="startDate"
                           [disabled]="loadingSave"></app-date-picker>
          <small class="form-text text-muted">
            If this is left blank, the customer chooses a start date when they purchase, if the
            membership allows that. Otherwise the roster membership starts on the day it is purchased.
          </small>
          <app-roster-invite-first-bill [rosterId]="selectedRoster ? selectedRoster.id : null"
                                        [startDate]="startDate"></app-roster-invite-first-bill>
        </div>

      </ng-container>

    </ng-container>

    <div class="form-group">

      <label>Customers to Invite</label>

      <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
              *ngIf="!allCustomersAreSelected()"
              (click)="setAllCustomersSelected()">
        Select All
      </button>
      <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
              *ngIf="allCustomersAreSelected()"
              (click)="selectedCustomerIds = []"
              [disabled]="loadingSave"
              [class.disabled]="loadingSave">
        Deselect All
      </button>

      <div class="form-check ml-3" *ngFor="let res of getFilteredParticipants()">
        <ng-container *ngIf="res.customer_id">
          <input class="form-check-input" type="checkbox"
                 [id]="'customer-' + res.customer_id"
                 [disabled]="loadingSave"
                 [class.disabled]="loadingSave"
                 [checked]="selectedCustomerIds.includes(res.customer_id)"
                 (change)="toggleSelectedCustomerId(res.customer_id)">
          <label class="form-check-label"
                 [for]="'customer-' + res.customer_id">
            <b>{{ res.last_name }}, {{ res.first_name }}</b>
            <ng-container *ngIf="propExistsAndIsNonEmpty(res.birthday)">
              ({{ getAge(res.birthday) }}), born {{ dateStringFromISO8601(res.birthday) }}
            </ng-container>
          </label>
        </ng-container>
        <ng-container *ngIf="!res.customer_id">
          <input class="form-check-input disabled" type="checkbox"
                 disabled>
          <label class="form-check-label text-muted">
            {{ res.last_name }}, {{ res.first_name }}
            (Unlinked)
          </label>
        </ng-container>
      </div>

    </div>

    <app-age-restriction-bypass-warning [violations]="ageRestriction.violations"
                                        [(acknowledged)]="ageRestriction.acknowledged"
                                        [disabled]="loadingSave"></app-age-restriction-bypass-warning>

    <app-invite-expiry-input [idPrefix]="'inviteParticipants'"
                             [(expiry)]="expiry"
                             [timeZone]="expiryTimeZone()"
                             [disabled]="loadingSave"></app-invite-expiry-input>

    <div class="form-group">
      <label>Invite Note (optional)</label>
      <app-markdown-editor [id]="'inviteNote'"
                           [(content)]="inviteNote"
                           [shortEditor]="true"></app-markdown-editor>
      <small class="form-text text-muted">
        This text will be included in the invite, underneath information about the event and (if configured above) the booking deadline.
      </small>
    </div>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox"
               id="sendInviteToParentsAndGuardians"
               name="sendInviteToParentsAndGuardians"
               [disabled]="loadingSave"
               [class.disabled]="loadingSave"
               [(ngModel)]="sendInviteToParentsAndGuardians">
        <label class="form-check-label"
               for="sendInviteToParentsAndGuardians">
          Send invite to linked parents &amp; guardians
        </label>
      </div>
      <small class="form-text text-muted">
        If selected, the invite will be sent to any linked parents and guardians of the participant to accept or reject the invite on behalf of the participant. This is in addition to the participant's own email address.
      </small>
    </div>

    <ng-container *ngIf="loadingSave">
      <h4>Loading...</h4>

      <div class="progress">
        <div class="progress-bar" role="progressbar" [style]="{width: getLoadingProgressPercentageStr() + '%'}"
             attr.aria-valuenow="{{ getLoadingProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </ng-container>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary" type="button"
            *ngIf="!loadingSave"
            [disabled]="!sendInvitesAllowed()"
            [class.disabled]="!sendInvitesAllowed()"
            (click)="handleSendInvites()">
      Send Invites
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
